var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ErrorsDisplay',_vm._l((_vm.extractErrors(_vm.validatitationErrors)),function(error,index){return _c('div',{key:("error-" + index)},[_c('span',[_vm._v(_vm._s(error))])])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }